const handlePriceSammaryOpen = ()=>{
   // event.target.classList.toggle("open")
   document.querySelector(".price-summary-wrapper").classList.toggle("open");
   document.querySelector(".calculation-of-saving").classList.toggle("open");
}

function addWellnessClub(variantId) {

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(() => {

    const cartDrawer = document.querySelector('#MinimogCartDrawer');

    if (cartDrawer) {
      cartDrawer.onCartDrawerUpdate();
    }

  })
  .catch(error => {
    console.log(error);
  });
}

const handleInputChange = (e)=> {
  const aplBtn =document.getElementById("apply_with_btn")
  aplBtn.disabled = e.target.value.trim() === "";
}

const discountModalopen = async ()=>{
   document.querySelector(".discount-modal").classList.add("open-offer");
   
       
             
}
const discountModalclose = ()=>{
   document.querySelector(".discount-modal").classList.remove("open-offer");
}

const applyDiscount = (code)=>{
   $.ajax({
      url:`https://www.itsdope.shop/discount/${code}`,
      success: function(data) {
        console.log(data)
        alert("Your discount has been applied!");
      }
    }); 
     // $('#MinimogCartDrawer').load('#MinimogCartDrawer');
}